import React, { useState, useEffect } from 'react';
import { isAuthenticated } from '../../store/action/auth';
import axios from "axios";
import {API} from "../../config";
import { PDFDownloadLink, Page, Text, View, Document, StyleSheet, Image } from '@react-pdf/renderer';

const PurchaseOrderPDF = (props) => {
    const { token } = isAuthenticated();
    const [ loading, setLoading ] = useState(true);
    const [ purchaseOrder, setPurchaseOrder ] = useState({
        id: "",
        warehouseName: "",
        warehouseAddress: "",
        deliveryDate: "",
        status: "",
        items: [],
        note: "",
        userId: "",
        userName: "",
        userOrganization: "",
        supplierId: "",
        supplierName: "",
        supplierContactName: "",
        supplierContactPhone: "",
        catalogId: "",
        catalogName: "",
        catalogProducts: []
    });

    useEffect(() => {
        _fetchData()
    }, []);

    const _fetchData = async () => {
        try {
            const res = await axios.get(`${API}/v1/purchase_orders/${props.match.params.purchaseOrderId}`,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Accept: 'application/json',
                        Authorization: `Bearer ${token}`
                    },
                });
            if (res.data.success) {
                let {data} = res;
                setPurchaseOrder({
                    id: data.id,
                    warehouseName: data.warehouse_name,
                    warehouseAddress: data.warehouse_address,
                    deliveryDate: data.delivery_date,
                    status: data.status,
                    items: data.items,
                    note: data.note,
                    userId: data.user_id,
                    userName: data.user_name,
                    userOrganization: data.user_organization,
                    supplierId: data.supplier_id,
                    supplierName: data.supplier_name,
                    supplierContactName: data.supplier_contact_name,
                    supplierContactPhone: data.supplier_contact_phone,
                    catalogId: data.catalog_id,
                    catalogName: data.catalog_name,
                    catalogProducts: data.catalog_products
                });
            } else {
                alert(res.error)
            }
        } catch (e) {
            console.log (e);
            alert(e.error)
        }
        setLoading(false)
    };

    // Create Document Component
    const PDFDocument = () => {
        let qrcodes = () => {
            let productSec = [];
            let qrSec = [];
            for (let i = 0; i < purchaseOrder.items.length; i++ ) {

                for (let j = 0; j < purchaseOrder.items[i].quantity; j++) {
                    qrSec.push(
                        <View key={j} style={{ alignItems:'center', margin: 2}}>
                            <Image
                                style={{ height:52, width:52, display:'inline-block'}}
                                src={`https://api.qrserver.com/v1/create-qr-code/?size=35x35&data=${purchaseOrder.items[i].sku}`}
                            />
                            <Text style={{ fontSize: 6}}>{purchaseOrder.items[i].sku}</Text>
                        </View>
                    )
                }

                productSec.push(
                    <View key={i} style={{marginTop:16,marginLeft:12}}>
                        <Text>{purchaseOrder.items[i].name} - {purchaseOrder.items[i].sku}</Text>
                        <View style={{flexDirection: 'row',flexWrap: 'wrap'}}>
                            { qrSec }
                        </View>
                    </View>
                );
                qrSec = [];
            }
            return productSec
        };

        return (
            <Document>
                <Page size="A4" style={PDFStyles.page}>
                    <View>
                        {qrcodes()}
                    </View>
                </Page>
            </Document>
        )
    };

    if (loading) {
        return <p>Loading...</p>
    }

    return (
        <div className="bg-white rounded shadow p-4">
            <h2 className="text-center">Download PDF</h2>
            <div className="my-4"/>
            <div className="row">
                <div className="col-4"/>
                {
                    purchaseOrder.items.length === 0 ? null :
                        <div className="input-group col-4">
                            <PDFDownloadLink className="btn-block btn btn-light" document={!loading && <PDFDocument />} fileName={`purchase-order-${purchaseOrder.id}.pdf`}>
                                {({ blob, url, loading, error }) => (loading ? 'Loading document...' : 'Download Barcode')}
                            </PDFDownloadLink>
                        </div>
                }
            </div>
        </div>
    )
};

// Create styles
const PDFStyles = StyleSheet.create({
    page: {
        backgroundColor: '#E4E4E4',
        flex:1
    },
    section: {
        margin: 15,
        padding: 10,
        flexDirection:'row',
        flex:1,
        flexWrap:'wrap'
    }
});


export default PurchaseOrderPDF;
